export const EditorialLogo = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 130">
    <path
      className="cls-1"
      fill="#e20411"
      d="M0,0H300a0,0,0,0,1,0,0V118a12,12,0,0,1-12,12H12A12,12,0,0,1,0,118V0A0,0,0,0,1,0,0Z"
    />
    <rect className="cls-2" fill="#c60c0d" x="29.88" width="30" height="130" />
    <rect className="cls-2" fill="#c60c0d" x="90.38" width="30" height="130" />
    <rect className="cls-2" fill="#c60c0d" x="150.38" width="30" height="130" />
    <rect className="cls-2" fill="#c60c0d" x="210.38" width="30" height="130" />
    <path
      className="cls-2"
      fill="#c60c0d"
      d="M270,0h30a0,0,0,0,1,0,0V118a12,12,0,0,1-12,12H270a0,0,0,0,1,0,0V0A0,0,0,0,1,270,0Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M23,105.19H14.68V62.89H22.9l9.48,24.66L41.8,62.89H50v42.3H41.74V80.77l-6.6,16.5H29.5L23,80.89Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M76.12,96.85H63.82l-2.34,8.34h-8.4L65.5,62.89h9.06l12.23,42.3H78.33Zm-1.74-7.14L70.06,73.15l-4.5,16.56Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M116.79,91.21c0,8.64-5.82,14.58-14.21,14.58S88.42,99.85,88.42,91.21V76.75c0-8.64,5.82-14.64,14.16-14.64s14,5.88,14.21,14.28h-8.28c0-4.5-2.34-6.36-5.81-6.36C99,70,96.76,72,96.76,77.59V91.51c0,4.32,2.22,6.36,5.82,6.36,3,0,5.93-1.68,5.93-6.36v-.72h-5.88V83.53h14.16Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M141.63,96.85h-12.3L127,105.19h-8.4L131,62.89h9.06l12.24,42.3h-8.46Zm-1.74-7.14-4.32-16.56-4.5,16.56Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M153.57,74.53c0-7.74,5.52-12.42,13.92-12.42,8.16,0,13.8,5.46,13.8,14.16h-8.16c0-4.5-2.22-6.6-5.76-6.6s-5.52,1.68-5.52,4.86c0,8.4,20,3.42,20,18.54,0,8-5.76,12.84-14.34,12.84S153,100.33,153,91.27h8.28c0,4.92,2.52,7,6.18,7,3.48,0,6.06-1.62,6.06-5.1C173.55,85.09,153.57,89.53,153.57,74.53Z"
    />
    <path className="cls-3" fill="#fff" d="M186.87,105.19V62.89h8.28v42.3Z" />
    <path
      className="cls-3"
      fill="#fff"
      d="M222.93,105.19,210.45,80.71v24.48h-8.28V62.89H210l12.42,24.6V63h8.34v42.18Z"
    />
    <path
      className="cls-3"
      fill="#fff"
      d="M245.67,70.87v9.6h11.46v7.2H245.67v9.6h15.48v7.92H237.39V62.89h23.76v8Z"
    />
    <path className="cls-3" fill="#fff" d="M280.71,70.87v34.32h-8.28V70.87h-8.82v-8h25.92v8Z" />
  </svg>
);
